import moment from "moment";
import { Card } from "@mui/material";
import { useEffect, useState } from "react";
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined } from "@mui/icons-material";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import DataTable from "../../components/DataTable";
import CustomStatusCell from "../../components/CustomStatusCell";
import WorkerNodeService from "../../services/base/workerNode.service";

import { MainComponent } from "../main";
import { Constants } from "../../constants/constants";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";



export enum CleanupNodeType {
    None,
    CleanUp
}

export enum NodeType {
    Actual,
    Container
}

interface IRequestGetPaged {
    cleanUpNode?: number;
    orderby?: string;
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;
}

export interface IRecordWorkernode {
    id?: string;
    nodeType?: number;
    hostName?: string;
    generatorId?: string;
    cleanupNode?: number;
    epochTime?: string;
    launchTime?: string;
    terminatedTime?: string;

    status?: number;
    createTime?: string;
    createUser?: string;
    updateTime?: string;
    updateUser?: string;
}

interface IModel {
    requestData?: IRequestGetPaged;
}


const WorkerNodeContainer = (props: {
    domainName: string; //
    request: IRequestGetPaged;
    onGetPaged: (query: string, totalCount: number) => void;
    onNavigate: (data?: { id?: string, mode?: number }) => void;
}) => {
    const Strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [model, setModel] = useState<IModel>({} as IModel);
    const [dataRows, setDataRows] = useState<IRecordWorkernode[]>([]);

    useEffect(() => {
        const onStarted = async () => {
            const newReq: IRequestGetPaged = {
                totalCount: props.request?.totalCount || 0,
                pageSize: props.request?.pageSize || model?.requestData?.pageSize,
                pageNumber: props.request?.pageNumber || model?.requestData?.pageNumber,
                cleanUpNode: Helpers.isNullOrEmpty(props.request?.cleanUpNode)
                    ? model?.requestData?.cleanUpNode
                    : props.request?.cleanUpNode,
            };

            await getPaged(newReq);
        };
        onStarted();
    }, [props.request]);

    const getPaged = async (dataReq?: IRequestGetPaged) => {
        try {
            onShowLoading();

            const pageSize = dataReq?.pageSize || Constants.ROW_PER_PAGE;
            const pageNumber = Helpers.getPageNumber(dataReq?.pageNumber || 1, pageSize, dataReq?.totalCount || 0);

            const newRequest: any = {
                pageSize,
                pageNumber,
                cleanUpNode: dataReq?.cleanUpNode,
            };

            const result = await WorkerNodeService.getPaged(props.domainName, newRequest);

            setDataRows([...result?.items || []]);

            setModel({
                requestData: {
                    ...newRequest,
                    totalCount: result?.totalCount || 0,
                },
            });

            let query: string = `?pageNumber=${newRequest?.pageNumber}&pageSize=${newRequest?.pageSize}`;
            if (!Helpers.isNullOrEmpty(newRequest?.cleanUpNode)) {
                query = query + `&cleanUpNode=${newRequest?.cleanUpNode}`;
            }

            props.onGetPaged(query, result?.totalCount || 0);
            onHideLoading();
        } catch (error) {
            onHideLoading();
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    const handleUpdateRow = async (id: string) => {
        Helpers.showConfirmAlert(Strings.WORKER_NODE.CONFIRM_UPDATE, async () => {
            try {
                onShowLoading();

                const result = await WorkerNodeService.update(props.domainName, id);
                if (result.statusCode === 200) {
                    await getPaged(model.requestData);
                }

                onHideLoading();
                onSuccess(Strings.WORKER_NODE.UPDATE_SUCCESS);
            } catch (error) {
                onHideLoading();
                const e = Helpers.renderExceptionError(error);
                onError(e);
            }
        });
    };

    const formatDate = (props: { value?: any, format?: string }) => {
        if (Helpers.isNullOrEmpty(props.value) || props.value === 0 || props.value === "0") {
            return "";
        } else {
            return moment(Number(props.value) * 1000).format(props.format || "DD/MM/YYYY")
        }
    }

    return (
        <MainComponent>
            <Card>
                <Box p={2}>
                    <DataTable
                        rowPerPage={model.requestData?.pageSize}
                        pageNumber={model.requestData?.pageNumber}
                        totalCount={model.requestData?.totalCount}
                        onChangePageSize={(pageSize) => getPaged({ ...model.requestData, pageSize })}
                        onChangePageNumber={(pageNumber) => getPaged({ ...model.requestData, pageNumber })}

                        table={{
                            rows: dataRows || [],
                            columns: [
                                {
                                    Header: Strings.WORKER_NODE.HOST_NAME, accessor: "hostName", width: "150px",
                                },
                                {
                                    Header: Strings.WORKER_NODE.CLEANUP_NODE, accessor: "cleanupNode", width: "100px",
                                    Cell: (row) => <>{
                                        (Number(row.value) === CleanupNodeType.CleanUp)
                                            ? <CheckBoxOutlined /> : <CheckBoxOutlineBlankOutlined />
                                    }</>,
                                },
                                {
                                    Header: Strings.WORKER_NODE.LAUNCH_TIME, accessor: "launchTime", width: "120px",
                                    Cell: (row) => <>{formatDate(row?.value)}</>,
                                },
                                {
                                    Header: Strings.WORKER_NODE.TERMINATED_TIME, accessor: "terminatedTime", width: "120px",
                                    Cell: (row) => <>{formatDate(row?.value)}</>,
                                },
                                {
                                    Header: Strings.Common.STATUS, accessor: "status", width: "150px",
                                    Cell: ({ value }: any) => <CustomStatusCell status={value} />
                                },
                            ],
                        }}

                        actionList={(row) => [
                            // {
                            //     key: "edit",
                            //     iconName: "edit",
                            //     title: Strings.Common.UPDATE,
                            //     callback: (row) => {
                            //         handleUpdateRow(row.id)
                            //     },
                            // },
                        ]}
                    />
                </Box>
            </Card>
        </MainComponent>
    );
};

export default WorkerNodeContainer;
